import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "Trail Tales",
    date: "10 April, 2025",
    admin: "Admin",
    heading: "10 Must-Hike Trails For Beginners",
    important: {
      content: "Gain valuable insights from experienced hikers and guides to make the most of your hiking journey. Whether it's choosing the right trail or navigating through challenging terrain, their expertise will help you embark on unforgettable adventures.",
      intro: "Experienced Hiker"
    },
    paragraph: {
      para1: "Explore the top 10 hiking trails perfect for beginners. From scenic strolls to easy-going paths, discover breathtaking landscapes and stunning natural wonders. Gain confidence in your hiking skills while immersing yourself in the beauty of nature.",
      para2: "Learn about essential hiking techniques, safety tips, and what to pack for your adventure. Whether you're looking for a leisurely day hike or a weekend getaway, these beginner-friendly trails offer something for everyone.",
      para3: "Discover the beauty of hiking and explore these beginner-friendly trails. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Get inspired by the beauty of beginner-friendly hiking trails through our curated gallery. Let these images motivate you to lace up your boots and explore the great outdoors! Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2,
    ],
    tags: ["Hiking", "Trails", "Beginners"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "Olivia Williams",
        date: "21 May, 2025",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur.",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Alexander Smith",
            date: "22 May, 2025",
            content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Christopher Brown",
        date: "22 May, 2025",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "Gear Guides",
    date: "05 April, 2025",
    admin: "Admin",
    heading: "Essential Camping Gear Checklist for Beginners",
    important: {
      content: "Start your camping journey fully prepared by understanding what essential gear you truly need. From reliable tents to proper cooking tools, this guide will help you pack smart and camp with confidence.",
      intro: "Outdoor Enthusiast"
    },
    paragraph: {
      para1: "Planning your first camping trip? This essential checklist breaks down everything a beginner camper needs. From shelter and sleeping gear to lighting and cookware, we cover all the basics so you’re never caught off guard in the wild.",
      para2: "Learn how to choose the right equipment, maintain safety, and ensure comfort on your outdoor adventure. Whether you’re car camping or backpacking into the woods, having the right gear makes all the difference.",
      para3: "Discover pro tips on gear organization, storage hacks, and what to skip if you’re packing light. Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit rerum facere repellendus, deleniti modi amet illo sequi. Quasi, earum mollitia.",
      para4: "Get inspired by our visual checklist and curated gear gallery. From compact cookware to comfy sleeping bags, these images will help you picture your perfect campsite setup. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsam pariatur voluptates dicta unde, impedit alias deserunt magnam fuga reiciendis accusamus?"
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2,
    ],
    tags: ["Camping", "Beginners", "Gear"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Emma Johnson",
        date: "16 June, 2025",
        content: "Thanks for this list! It’s really helpful for someone like me who's planning a first-time camping trip.",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Liam Davis",
            date: "17 June, 2025",
            content: "Same here! I didn’t realize how important a headlamp is until I read this."
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Sophia Martinez",
        date: "17 June, 2025",
        content: "Loved the gallery. Visual references really helped me figure out what gear I already have and what I still need."
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Discoveries",
    date: "25 March, 2025",
    admin: "Admin",
    heading: "Best Winter Hiking Trails: Where to Trek in the Snow",
    important: {
      content: "Embrace the beauty of winter by exploring snow-covered trails that offer breathtaking views and serene landscapes. With the right preparation, cold-weather hiking can be magical, peaceful, and unforgettable.",
      intro: "Winter Trail Expert"
    },
    paragraph: {
      para1: "Discover some of the most stunning winter hiking trails perfect for those who love snow-dusted forests, frozen waterfalls, and quiet, peaceful paths. These handpicked trails combine scenic beauty with beginner- to intermediate-level terrain.",
      para2: "Get essential tips for winter hiking, including how to layer your clothing, pick the right footwear, and stay safe in icy or snowy conditions. Learn what to pack so you're ready for anything from a crisp morning walk to a full-day snow trek.",
      para3: "Experience the magic of winter hiking. Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto officia, nisi totam harum unde voluptate veniam laborum repellendus. Aspernatur, deleniti magni!",
      para4: "Get inspired by our winter trail photo gallery. Snowy peaks, frosted trees, and golden hour lighting—these images will make you want to grab your boots and hit the trail. Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque, placeat nobis."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2,
    ],
    tags: ["Winter", "Hiking", "Trails"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Noah Thompson",
        date: "11 December, 2025",
        content: "Winter hikes are my favorite! Appreciate the safety tips, especially the part about layering correctly.",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "Ava Moore",
            date: "12 December, 2025",
            content: "Agreed! I once underestimated the cold—never again. Great checklist in this blog!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Ethan Miller",
        date: "12 December, 2025",
        content: "Beautiful gallery. These trails look straight out of a winter postcard!"
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Safety Spotlights",
    date: "19 March, 2025",
    admin: "Admin",
    heading: "Wilderness Survival Skills: Tips for Emergencies",
    important: {
      content: "Learn how to handle unexpected situations in the wild with confidence. These essential survival skills can help you stay safe, think clearly, and make smart decisions when emergencies strike in remote locations.",
      intro: "Survival Specialist"
    },
    paragraph: {
      para1: "From getting lost on a trail to facing sudden weather changes, nature can be unpredictable. This guide covers the most important wilderness survival skills every hiker and camper should know, from building a shelter to signaling for help.",
      para2: "Understand how to find clean water, make a fire without matches, and identify edible plants. These practical tips are designed to help you stay calm and act quickly in high-stress situations while exploring the outdoors.",
      para3: "Preparedness is key to surviving any outdoor emergency. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sint harum rerum, nulla placeat earum excepturi quis, incidunt voluptas soluta ab.",
      para4: "Browse our survival gallery for visual demonstrations of fire-making, shelter-building, and tool usage. Let these images reinforce your learning and inspire confidence in your skills. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem facere adipisci repellat minus iusto ullam."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2,
    ],
    tags: ["Survival", "Hiking", "Tips"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Liam Anderson",
        date: "6 January, 2025",
        content: "I never realized how important it is to know basic survival tactics. Great write-up!",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "Mia Garcia",
            date: "7 January, 2025",
            content: "Absolutely! The fire-starting and shelter tips are game-changers."
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Benjamin Davis",
        date: "7 January, 2025",
        content: "These tips are essential for anyone who loves backcountry hikes. Appreciate the thorough advice!"
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Community",
    date: "07 March, 2025",
    admin: "Admin",
    heading: "Tips for Adventurous Canine Companions",
    important: {
      content: "Make every outdoor experience paw-some for your four-legged friend. Learn how to keep your dog safe, happy, and energized on hiking trails, camping trips, and other wilderness adventures.",
      intro: "Dog Trekking Expert"
    },
    paragraph: {
      para1: "Planning an outdoor adventure with your dog? This guide shares essential tips for hiking, camping, and exploring nature safely with your pup. From gear recommendations to trail etiquette, ensure your furry buddy has as much fun as you do.",
      para2: "Discover the best practices for hydration, paw protection, and managing wildlife encounters. Learn how to read your dog’s energy levels and make rest stops when needed. These tips ensure both you and your dog stay comfortable and safe in the wild.",
      para3: "Canine adventures can be incredibly rewarding. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates est, mollitia excepturi provident molestias deleniti nesciunt nobis.",
      para4: "Check out our gallery of dogs on the trail! From wagging tails to summit views, get inspired by fellow adventurers who bring their pups along for the ride. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat, itaque!"
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2,
    ],
    tags: ["Dogs", "Hiking", "Tips"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Emily Johnson",
        date: "16 January, 2025",
        content: "Loved this article! I always bring my golden retriever on hikes, and these tips were super helpful.",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Daniel Lee",
            date: "17 January, 2025",
            content: "Same here! The part about paw protection really helped me choose the right boots for my dog."
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "Sophia Martinez",
        date: "17 January, 2025",
        content: "Great info! I’m planning a weekend camping trip with my husky—bookmarking this for sure."
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "Trail Tales",
    date: "01 March, 2025",
    admin: "Admin",
    heading: "Solo Trekking: Tips for Exploring Alone",
    important: {
      content: "Solo trekking offers a unique sense of freedom and self-discovery. Equip yourself with the right mindset, safety practices, and trail preparation tips to enjoy peaceful and empowering solo adventures.",
      intro: "Solo Hiker Insights"
    },
    paragraph: {
      para1: "Embarking on a solo trek can be both empowering and refreshing. This guide highlights how to plan your route, stay safe, and embrace the solitude of nature. It’s all about preparation and confidence when you're hiking alone.",
      para2: "Learn about emergency preparedness, choosing low-risk trails, and how to check in with someone before heading out. From what gear to bring to maintaining awareness of your surroundings, these tips are tailored for the independent adventurer.",
      para3: "Experience the power of hiking solo. Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi officiis fuga laborum, quas quo quidem voluptatum.",
      para4: "Take a look at our gallery of solo hikers in action. From serene lake views to mountain sunrises, be inspired to start your own solo journey. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi, nostrum!"
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2,
    ],
    tags: ["Solo", "Hiking", "Tips"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Liam Carter",
        date: "26 January, 2025",
        content: "I've been wanting to try solo hiking—this gave me the confidence to finally go for it!",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Natalie Brooks",
            date: "27 January, 2025",
            content: "Same here! I appreciate the reminder to share my itinerary with someone. Great safety tip."
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "Henry Clark",
        date: "27 January, 2025",
        content: "This post spoke to me. There’s something magical about being alone with nature. Thanks for the guide!"
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "Trail Tales",
    date: "29 February, 2025",
    admin: "Admin",
    heading: "Top 10 Beginner-Friendly Hiking Trails",
    important: {
      content: "Step into the world of hiking with these handpicked trails perfect for beginners. Enjoy stunning scenery, gentle paths, and the chance to build your skills with confidence and ease.",
      intro: "Beginner Trail Guide"
    },
    paragraph: {
      para1: "Ready to start hiking but not sure where to go? This list of beginner-friendly trails is designed to ease you into outdoor adventures with manageable paths, rewarding views, and safe environments.",
      para2: "Discover trails that are ideal for families, solo explorers, or anyone looking to dip their toes into hiking. We’ve considered distance, terrain, and scenic value to ensure your first experiences are nothing short of amazing.",
      para3: "Explore nature without the stress. Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita ad nemo pariatur sit officiis commodi esse adipisci itaque voluptatum!",
      para4: "Be inspired by real snapshots from these top-rated beginner hikes in our gallery. Let these peaceful landscapes motivate you to get outside. Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe, adipisci!"
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2,
    ],
    tags: ["Hiking", "Trails", "Beginners"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Emma Thompson",
        date: "31 January, 2025",
        content: "I’ve hiked two from this list already—great recommendations for newbies!",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "James Foster",
            date: "01 February, 2025",
            content: "Which ones did you try? I’m planning my first hike next weekend!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Sophie Turner",
        date: "01 February, 2025",
        content: "Love this list! Exactly what I needed to start hiking without feeling overwhelmed."
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Gear Guides",
    date: "21 February, 2025",
    admin: "Admin",
    heading: "Beginner's Guide to Essential Camping Gear",
    important: {
      content: "Get started with the right gear for a safe and enjoyable camping experience. From tents to cooking supplies, learn what you truly need—and what you can skip—when heading into the wild.",
      intro: "First-Time Camper"
    },
    paragraph: {
      para1: "New to camping? This guide covers all the must-have gear you need to stay comfortable, safe, and prepared. Whether you're camping in the mountains or near a peaceful lake, having the right equipment makes all the difference.",
      para2: "We break down the camping essentials: tents, sleeping bags, cooking gear, lighting, first-aid kits, and more. Learn how to choose reliable gear that suits your environment and trip length without overpacking.",
      para3: "Embark on your camping journey with confidence. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus autem, repellendus quas fugiat optio ex omnis soluta saepe!",
      para4: "Browse through our gear gallery to get inspired by smart setups and compact packing ideas. Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto earum culpa incidunt modi nulla, asperiores impedit sit laborum doloremque."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2,
    ],
    tags: ["Camping", "Beginners", "Gear"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Daniel Evans",
        date: "3 February, 2025",
        content: "Super helpful! I was overwhelmed by gear options, but this simplified everything.",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Lara Martin",
            date: "3 February, 2025",
            content: "Same here! I especially appreciated the tip about compact stoves."
          }
        ]
      },
      {
        id: 2,
        image: images.blog8Comment3,
        name: "Natalie Brooks",
        date: "4 February, 2025",
        content: "This helped me prep for my first camping trip. Great checklist!"
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Discoveries",
    date: "15 February, 2025",
    admin: "Admin",
    heading: "Top Winter Hiking Spots: Best Trails for Snow Trekkers",
    important: {
      content: "Experience the serene beauty of snow-covered landscapes as you explore these incredible winter hiking destinations. Perfect for cold-weather adventurers, these trails offer scenic views and a peaceful escape from the crowds.",
      intro: "Winter Trail Guide"
    },
    paragraph: {
      para1: "Discover some of the best trails for winter hiking across breathtaking snowy terrains. Whether you're looking for a frosty forest path or a mountain route blanketed in white, these trails are ideal for cold-season exploration.",
      para2: "Get tips on winter hiking safety, layering clothing, essential gear, and staying warm on the trail. These winter wonderlands are perfect for both beginners and seasoned hikers who enjoy trekking in cooler conditions.",
      para3: "Snow trekking opens up a magical world. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ullam quibusdam voluptatibus eos suscipit repellendus incidunt expedita dolore eaque saepe eveniet.",
      para4: "Check out our gallery of stunning winter landscapes captured along these hikes. Let these visuals inspire your next cold-weather adventure. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur vel aut corrupti non aspernatur accusantium, culpa ipsa!"
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2,
    ],
    tags: ["Winter", "Hiking", "Trails"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Isabella Green",
        date: "6 February, 2025",
        content: "Absolutely love winter hikes—this list is fantastic!",
        replies: [
          {
            id: 1,
            image: images.blog9Comment2,
            name: "Ethan Carter",
            date: "6 February, 2025",
            content: "Agreed! I’ve tried two of these and they’re amazing in the snow."
          }
        ]
      },
      {
        id: 2,
        image: images.blog9Comment3,
        name: "Mason Lee",
        date: "7 February, 2025",
        content: "Thanks for the gear tips—makes a huge difference out in the cold!"
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Safety Spotlights",
    date: "06 February, 2025",
    admin: "Admin",
    heading: "Essential Wilderness Survival Tips for Emergencies",
    important: {
      content: "Equip yourself with life-saving skills for unexpected outdoor situations. From finding shelter to signaling for help, these survival tips are vital for anyone venturing into the wild.",
      intro: "Wilderness Survival Expert"
    },
    paragraph: {
      para1: "Learn the fundamentals of surviving in the wilderness. This guide covers essential tips like building a fire, purifying water, creating a temporary shelter, and navigating without a GPS.",
      para2: "Understand how to assess your environment, prioritize tasks during an emergency, and stay calm under pressure. These techniques can significantly increase your chances of staying safe until help arrives.",
      para3: "In survival situations, knowledge is power. Lorem ipsum dolor sit amet consectetur, adipisicing elit. At iusto perspiciatis, exercitationem quo deserunt adipisci nisi quasi, velit placeat.",
      para4: "Our gallery showcases real-world survival scenarios and setups. Let these images inspire your preparedness journey. Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia harum id saepe voluptatum temporibus fugit dolorem."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2,
    ],
    tags: ["Survival", "Tips", "Hiking"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Liam Turner",
        date: "13 February, 2025",
        content: "This article is a must-read for every outdoor enthusiast. Great insights!",
        replies: [
          {
            id: 1,
            image: images.blog10Comment2,
            name: "Sophia Bennett",
            date: "13 February, 2025",
            content: "Absolutely! I’ve started packing a survival kit thanks to this post."
          }
        ]
      },
      {
        id: 2,
        image: images.blog10Comment3,
        name: "Aiden Clark",
        date: "14 February, 2025",
        content: "Super useful info. You never know when you’ll need these skills."
      }
    ]
  },
  {
    id: 11,
    image: images.blog11,
    category: "Community",
    date: "27 January, 2025",
    admin: "Admin",
    heading: "Guidelines for Hiking with Your Adventurous Dog",
    important: {
      content: "Bring your furry friend along on your next hike! Discover essential tips for hiking safely with your dog, ensuring both of you enjoy the journey.",
      intro: "Dog Hiking Enthusiast"
    },
    paragraph: {
      para1: "Hiking with your dog can be a rewarding experience, but it requires preparation. Learn the best practices for keeping your dog safe, healthy, and happy on the trails.",
      para2: "From choosing the right trail to packing dog-friendly essentials, this guide will help you ensure that both you and your dog have a great time on your outdoor adventures.",
      para3: "Understand your dog's needs during the hike and how to recognize signs of fatigue or distress. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquid, ab.",
      para4: "Take a look at our curated gallery of hiking dogs in action! Let these inspiring images encourage you to explore the great outdoors with your canine companion. Lorem ipsum dolor sit amet."
    },
    gallery: [
      images.blog11Gallery1,
      images.blog11Gallery2,
    ],
    tags: ["Dogs", "Hiking", "Guidelines"],
    comments: [
      {
        id: 1,
        image: images.blog11Comment1,
        name: "Emma Davis",
        date: "19 February, 2025",
        content: "This is super helpful! I can’t wait to take my dog on a hike this weekend.",
        replies: [
          {
            id: 1,
            image: images.blog11Comment2,
            name: "Lucas Evans",
            date: "20 February, 2025",
            content: "Same here! I just got some new gear for my dog, and I’m ready for the trails."
          }
        ]
      },
      {
        id: 2,
        image: images.blog11Comment3,
        name: "Oliver Harris",
        date: "20 February, 2025",
        content: "Great tips! I didn’t realize how important it is to pack water for the dog too."
      }
    ]
  },
  {
    id: 12,
    image: images.blog12,
    category: "Trail Tales",
    date: "22 January, 2025",
    admin: "Admin",
    heading: "Exploring Solo: Essential Tips for Solo Trekkers",
    important: {
      content: "Solo trekking offers an unparalleled sense of freedom and adventure. Here are some essential tips to help you make the most of your solo journey and stay safe along the way.",
      intro: "Solo Trekking Expert"
    },
    paragraph: {
      para1: "Solo trekking can be an incredibly rewarding experience, but it requires careful planning and preparation. Learn how to stay safe, navigate the wilderness, and enjoy solitude on the trails.",
      para2: "From choosing the right destination to packing the essentials, this guide provides all the information you need to set out on your solo trek with confidence.",
      para3: "Safety is paramount when hiking alone. We'll go over important safety precautions, including communication devices, route planning, and emergency protocols. Lorem ipsum dolor sit amet.",
      para4: "Solo trekking opens up a world of peace and reflection. Check out our gallery of solo trekkers embracing the adventure! Lorem ipsum dolor sit amet consectetur adipisicing elit."
    },
    gallery: [
      images.blog12Gallery1,
      images.blog12Gallery2,
    ],
    tags: ["Solo", "Hiking", "Tips"],
    comments: [
      {
        id: 1,
        image: images.blog12Comment1,
        name: "Sophia Martinez",
        date: "26 February, 2025",
        content: "These tips are perfect for someone like me who's thinking of going solo. Thanks for the advice!",
        replies: [
          {
            id: 1,
            image: images.blog12Comment2,
            name: "David Lee",
            date: "27 February, 2025",
            content: "You’re welcome! Solo treks are life-changing. Enjoy the journey!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog12Comment3,
        name: "James Wilson",
        date: "27 February, 2025",
        content: "I’m planning my first solo trek. This article helped me get prepared!"
      }
    ]
  }
];

export default blogs;